import { type CheckoutConfig } from "@highnoteplatform/types";

import { iframeUri } from "./config";

interface FrameConfig {
  uuid: string;
  checkoutConfig: CheckoutConfig;
}

export const buildFrame = ({
  uuid,
  checkoutConfig,
}: FrameConfig): HTMLIFrameElement => {
  const frame = document.createElement("iframe");

  // The client token is deliberately NOT placed in the URL — it is delivered
  // over the private MessagePort handshake (see ./handshake). Only non-secret
  // configuration travels in the frame src.
  const urlParameters = new URLSearchParams();
  urlParameters.set("environment", checkoutConfig.environment ?? "test");

  if (checkoutConfig.additionalFormSections) {
    urlParameters.set(
      "additionalFormSections",
      JSON.stringify(checkoutConfig.additionalFormSections)
    );
  }

  if (checkoutConfig.excludedCardBrands) {
    urlParameters.set(
      "excludedCardBrands",
      checkoutConfig.excludedCardBrands.join("|")
    );
  }

  if (checkoutConfig.submitButton) {
    urlParameters.set(
      "submitButton",
      JSON.stringify(checkoutConfig.submitButton)
    );
  }

  const frameSource = new URL(
    `${iframeUri}?${encodeURIComponent(urlParameters.toString())}`
  );

  frameSource.hash = uuid;

  frame.setAttribute("src", frameSource.toString());
  frame.setAttribute("allow", "clipboard-write");
  frame.style.setProperty("border", "none");

  return frame;
};
